module.exports = __webpack_public_path__ + "img/service.382efec2.png";